import { Referral, ReferralStatus } from './referral/types';

// Get user points
export const getUserPoints = async (userId: string): Promise<number> => {
  // Mock implementation
  return Math.floor(Math.random() * 1000);
};

// Update user points
export const updateUserPoints = async (userId: string, points: number): Promise<number> => {
  // Mock implementation
  console.log(`Updating points for user ${userId}: ${points}`);
  return points;
};

// Get user referrals
export const getUserReferrals = async (userId: string): Promise<Referral[]> => {
  // Mock implementation
  return Array(3).fill(null).map((_, index) => ({
    id: `referral-${index}`,
    referrerId: userId,
    referrerName: 'Test User',
    referrerEmail: 'user@example.com',
    refereeId: `referee-${index}`,
    refereeName: `Referee ${index + 1}`,
    refereeEmail: `referee${index + 1}@example.com`,
    status: index === 0 ? ReferralStatus.PENDING : 
           index === 1 ? ReferralStatus.APPROVED : 
           ReferralStatus.COMPLETED,
    points: 100 * (index + 1),
    createdAt: new Date(Date.now() - index * 86400000).toISOString(),
    convertedAt: index === 2 ? new Date().toISOString() : undefined,
    name: `Referee ${index + 1}`,
    email: `referee${index + 1}@example.com`,
    date: new Date(Date.now() - index * 86400000).toISOString()
  }));
};

// Send referral invitation
export const sendReferralInvitation = async (
  data: { name: string; email: string; phone?: string },
  method: string
): Promise<{ success: boolean; message?: string }> => {
  // Mock implementation
  console.log(`Sending invitation to ${data.name} (${data.email}) via ${method}`);
  return { success: true, message: 'Referral sent successfully' };
};

// Reject referral
export const rejectReferral = async (referralId: string): Promise<boolean> => {
  // Mock implementation
  console.log(`Rejecting referral ${referralId}`);
  return true;
};

// Delete user referral code by email
export const deleteUserReferralCodeByEmail = async (email: string): Promise<boolean> => {
  // Mock implementation
  console.log(`Deleting referral code for ${email}`);
  return true;
};

// Get all referrals
export const getAllReferrals = async (): Promise<Referral[]> => {
  // Mock implementation
  return Array(5).fill(null).map((_, index) => ({
    id: `referral-${index}`,
    referrerId: `user-${index}`,
    referrerName: `Referrer ${index + 1}`,
    referrerEmail: `referrer${index + 1}@example.com`,
    refereeId: `referee-${index}`,
    refereeName: `Referee ${index + 1}`,
    refereeEmail: `referee${index + 1}@example.com`,
    status: index % 3 === 0 ? ReferralStatus.PENDING : 
           index % 3 === 1 ? ReferralStatus.APPROVED : 
           ReferralStatus.COMPLETED,
    points: 100 * (index + 1),
    createdAt: new Date(Date.now() - index * 86400000).toISOString(),
    convertedAt: index % 3 === 2 ? new Date().toISOString() : undefined,
    name: `Referee ${index + 1}`,
    email: `referee${index + 1}@example.com`,
    date: new Date(Date.now() - index * 86400000).toISOString()
  }));
};

// Get user referral code
export const getUserReferralCode = async (userId: string): Promise<string> => {
  // Mock implementation
  return `REF${userId.substring(0, 4).toUpperCase()}`;
};

// Send activation email to newly referred user
export const sendReferralWelcomeEmail = async (
  user: { name: string; email: string; referralCode?: string }
): Promise<boolean> => {
  console.log(`Sending welcome email to ${user.name} (${user.email}) with code ${user.referralCode || 'N/A'}`);
  return true;
};

export const generateActivationToken = (): string => {
  return `token-${Math.random().toString(36).substring(2, 15)}`;
};

export const checkBusinessReferralLimit = async (businessId: string) => {
  return {
    limitReached: false,
    currentCount: 5,
    maxCount: 100,
    pendingAllowed: true
  };
};

export const activatePendingReferral = async (userId: string, businessId: string): Promise<boolean> => {
  console.log(`Activating pending referral for user ${userId} in business ${businessId}`);
  return true;
};

// Add the missing export
export const getPendingReferralsCount = async (businessId?: string): Promise<number> => {
  // Mock implementation
  return Math.floor(Math.random() * 10);
};

// Add the missing sendReferralActivationEmail function
export const sendReferralActivationEmail = async (
  email: string,
  name: string,
  activationToken: string,
  referralCode: string
): Promise<boolean> => {
  console.log(`Sending activation email to ${name} (${email}) with token ${activationToken} and code ${referralCode}`);
  // In a real app, this would send an actual email
  return true;
};
